/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LobAndOfficePermission } from './LobAndOfficePermission';
import {
    LobAndOfficePermissionFromJSON,
    LobAndOfficePermissionFromJSONTyped,
    LobAndOfficePermissionToJSON,
    LobAndOfficePermissionToJSONTyped,
} from './LobAndOfficePermission';

/**
 * 
 * @export
 * @interface UserProfileData
 */
export interface UserProfileData {
    /**
     * 
     * @type {string}
     * @memberof UserProfileData
     */
    apiKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileData
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileData
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileData
     */
    fullName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileData
     */
    enabled?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof UserProfileData
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserProfileData
     */
    roles: Set<string>;
    /**
     * 
     * @type {Set<LobAndOfficePermission>}
     * @memberof UserProfileData
     */
    permissions: Set<LobAndOfficePermission>;
}

/**
 * Check if a given object implements the UserProfileData interface.
 */
export function instanceOfUserProfileData(value: object): value is UserProfileData {
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function UserProfileDataFromJSON(json: any): UserProfileData {
    return UserProfileDataFromJSONTyped(json, false);
}

export function UserProfileDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfileData {
    if (json == null) {
        return json;
    }
    return {
        
        'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
        'roles': new Set(json['roles']),
        'permissions': (new Set((json['permissions'] as Array<any>).map(LobAndOfficePermissionFromJSON))),
    };
}

export function UserProfileDataToJSON(json: any): UserProfileData {
    return UserProfileDataToJSONTyped(json, false);
}

export function UserProfileDataToJSONTyped(value?: UserProfileData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'apiKey': value['apiKey'],
        'userId': value['userId'],
        'userName': value['userName'],
        'fullName': value['fullName'],
        'enabled': value['enabled'],
        'expirationDate': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString(),
        'roles': Array.from(value['roles'] as Set<any>),
        'permissions': (Array.from(value['permissions'] as Set<any>).map(LobAndOfficePermissionToJSON)),
    };
}

